import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock
} from "react-bootstrap";
import React, { Fragment } from "react";
import { compose, pure, withHandlers, withState } from "recompose";

import Button from "../../elements/CustomButton/CustomButton";
import CategorySelect from "./CategorySelect";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import { SaveButton } from "../../elements/ActionButtons/SaveButton";
import SideModal from "../../elements/Modal/SideModal";
import Switch from "react-bootstrap-switch";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import { withLoadingWait } from "../../hoc/withLoadingSpinner";

const categoriesParent = withState(
  "categoriesParent",
  "setCategoriesParent",
  ({ intl, data: { category } }) => {
    if (category && category[0] && category[0].categoriesParent) {
      let categoryToEdit = category[0];

      // console.log("29 - categoryToEdit=", categoryToEdit);
      if (categoryToEdit.categoriesParent.ids !== null) {
        categoryToEdit.categoriesParent.name = intl.formatMessage({
          id: categoryToEdit.categoriesParent.ids
        });
      }

      return {
        label: categoryToEdit.categoriesParent.name,
        value: categoryToEdit.categoriesParent.id,
        element: {
          lettrageAuto: categoryToEdit.categoriesParent.lettrageAuto,
          fluxTresorerie: categoryToEdit.categoriesParent.fluxTresorerie,
          auxiliarisable: categoryToEdit.categoriesParent.auxiliarisable,
          sensHabituel: categoryToEdit.categoriesParent.sensHabituel,
          categoryFamilyId: categoryToEdit.categoriesParent.categoryFamily.id,
          accountId: categoryToEdit.categoriesParent.account.id
        }
      };
    } else {
      return null;
    }
  }
);

const categoryName = withState(
  "categoryName",
  "setCategoryName",
  ({ intl, inputCategory, data: { category } }) => {
    //console.log("categoryName data", category, data.loading);

    if (inputCategory) return inputCategory;
    if (!data.loading && category) {
      if (category[0] && category[0].ids !== null) {
        category[0].name = intl.formatMessage({ id: category[0].ids });
      }
      return category[0] ? category[0].name : undefined;
    } else {
      return "default";
    }
  }
);

const categoryFamilyName = withState(
  "categoryFamilyName",
  "setCategoryFamilyName",
  ({ intl, inputCategory, data: { category } }) => {
    // console.log("75 - categoryFamilyName data", category, data.loading);

    if (!data.loading && category.length === 1) {
      if (category[0] && category[0].categoryFamily && category[0].categoryFamily.ids !== null) {
        category[0].familyName = intl.formatMessage({ id: category[0].categoryFamily.ids });
      }
      // console.log("83 - category[0].familyName=", category[0].familyName);
      return category[0] ? category[0].familyName : undefined;
    } else {
      // console.log("86 - return default");
      return "";
    }
  }
);


const category = withState(
  "category",
  "setCategory",
  ({ data: { category } }) => {
    //console.log("category", category);
    return category;
  }
);
const categoryActive = withState(
  "categoryActive",
  "setCategoryActive",
  ({ data: { category } }) => {
    return (
      (category &&
        category[0] &&
        category[0].companySettings[0] &&
        category[0].companySettings[0].active) ||
      false
    );
  }
);

const errors = withState("errors", "setErrors", {});

const handlers = withHandlers({
  validate: ({
    isEdit,
    categoriesParent,
    categoryName,
    categoryId,
    categoryActive,
    category,
    createCategory,
    updateCategory,
    companyId,
    setErrors
  }) => () => {
    if (isEdit === true) {
      // console.log("categoryActive", categoryActive);
      return updateCategory(
        categoryName,
        categoryId,
        categoryActive,
        category,
        categoriesParent
      );
    } else {
      if (!!categoriesParent && !!categoryName) {
        console.log("ISEDIT", isEdit, companyId);
        return createCategory(
          companyId,
          categoryName,
          categoriesParent,
          category
        );
      }
    }

    return setErrors({
      categoriesParent: !categoriesParent,
      categoryName: !categoryName
    });
  },

  deleteCategory: ({
    isDeletable,
    category,
    deleteCategory,
    companyId,
    history,
    setErrors
  }) => () => {
    if (isDeletable === true) {
      // console.log("144 - category:", category, history);
      return deleteCategory(companyId, category, history);
    }
  }
});

const data = graphql(Queries.getCategory, {
  options: ({ categoryId, companyId }) => {
    console.log("Queries.getCategory", categoryId);
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        categoryId,
        companyId
      }
    };
  }
});

const CreateCategorySideModal = ({
  title,
  sideModalVisible,
  setSideModalVisible,
  validate,
  deleteCategory,
  options,
  categoriesParent,
  setCategoriesParent,
  categoryName,
  setCategoryName,
  categoryFamilyName,
  setCategoryFamilyName,
  categoryActive,
  setCategoryActive,
  companyId,
  isEdit,
  setIsEdit,
  isGeneric,
  setIsGeneric,
  isDeletable,
  setIsDeletable,
  setCategoryId,
  errors,
  intl,
  data: { category },
  workInProgress
}) => {
  // console.log("189 - CreateCategorySideModal", category);
  // console.log("categoriesParent, categoryName", categoriesParent, categoryName);
  // category && category[0] && console.log("CATEGORY TO EDIT", category[0]);

  if (category && (category[0] === null || category[0] === undefined)) {
    console.log("CATEGORY NULL");
    setIsGeneric(false);
    setIsEdit(false);
    //setCategoryActive(true);
  }

  // const hasParent =
  //  (category && category[0] && category[0].categoriesParent) ||
  //  (isEdit ? false : true);
  // console.log("hasParent", hasParent);

  console.log("isEdit", isEdit);
  console.log("is Generic", isGeneric);

  if (setIsDeletable) {
    if (
      !isGeneric && category[0] &&
      category[0].ecritureLines.length === 0 
      // category[0].budgetItems.length === 0       // HAVE TO DELETE BUDGET
    )
      setIsDeletable(true);
    else setIsDeletable(false);
    console.log("is Deletable", isDeletable);
  }

  // if (category && category[0] && category[0].ids !== null) {
  //   category[0].name = intl.formatMessage({ id: category[0].ids });
  //   category[0].familyName = intl.formatMessage({ id: category[0].categoryFamily.ids });
  //   // console.log("220 - category[0]=", category[0]);
  // }

  // if (
  //   category &&
  //   category[0] &&
  //   category[0].categoriesParent &&
  //   category[0].categoriesParent.ids !== null
  // ) {
  //   category[0].categoriesParent.name = intl.formatMessage({
  //     id: category[0].categoriesParent.ids
  //   });
  // }

  // console.log("258 - categoryFamilyName=", categoryFamilyName);

  return (
    <SideModal
      title={title}
      visible={sideModalVisible}
      handleClose={() => {
        setSideModalVisible(false);
        setIsEdit && setIsEdit(false);
        setCategoryId && setCategoryId(null);
      }}
      width="medium-wide"
    >
      <Col xs={12}>
        <FormGroup
          validationState={
            errors.categoryName && !categoryName ? "error" : null
          }
        >
          <ControlLabel>
            <FormattedMessage
              id="ids_name"
              description="register new category name label"
              defaultMessage="Nom"
            />
          </ControlLabel>
          <FormControl
            //disabled={!hasParent || isGeneric}
            disabled={isGeneric}
            name="categoryName"
            value={categoryName}
            onChange={event => setCategoryName(event.target.value)}
          />
          {errors.categoryName && !categoryName && (
            <HelpBlock>
              <FormattedMessage id="ids_enterTheNameOfTheNewCategory" />
            </HelpBlock>
          )}
        </FormGroup>
      </Col>
      <Col xs={12}>
        <FormGroup
          validationState={
            errors.categoriesParent && !categoriesParent ? "error" : null
          }
        >
          <ControlLabel>
            <FormattedMessage id="ids_parentCategory" />
          </ControlLabel>
          <CategorySelect
            //disabled={!hasParent || isGeneric}
            disabled={isGeneric}
            companyId={companyId}
            value={categoriesParent}
            onlyParents
            expenseCategory={true}
            supplierCategory={true}
            collaboratorCategory={true}
            clientCategory={true}
            tiersCategory={false}
            invoiceCategory={true}
            onlyGenericCategory={true}
            onSelected={element => {
              console.log("318 - element=", element);
              if (
                element.element &&
                element.element.categoryFamily &&
                element.element.categoryFamily.ids
              ) {
                const familyName = intl.formatMessage({ id: element.element.categoryFamily.ids });
                setCategoryFamilyName(familyName);
              }
              setCategoriesParent(element)
            }
            }
          />
          {errors.categoriesParent && !categoriesParent && (
            <HelpBlock>
              <FormattedMessage id="ids_selectAParentCategory" />
            </HelpBlock>
          )}
        </FormGroup>
      </Col>

      {categoryFamilyName !== undefined && (
        <Col xs={12}>
          <FormGroup >
            <ControlLabel>
              <FormattedMessage
                id="ids_family"
              />
            </ControlLabel>
            <FormControl
              disabled={true}
              name="categoryFamilyName"
              value={categoryFamilyName}
              onChange={event => console.log("323 - event=", event)}
            />
          </FormGroup>
        </Col>
      )}

      {isEdit && (
        <Col xs={12}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage
                id="ids_status"
                description="define category active status label"
                defaultMessage="Statut"
              />
            </ControlLabel>
            <Fragment>
              <Switch
                onText=""
                offText=""
                value={categoryActive}
                onChange={() => {
                  setCategoryActive(!categoryActive);
                }}
              />
              <span style={{ marginLeft: "10px" }}>
                {!!categoryActive ? "Active" : "Inactive"}
              </span>
            </Fragment>
          </FormGroup>
        </Col>
      )}
      <Col xs={5}>
        {isDeletable && (
          <Button icon bsStyle="primary" onClick={deleteCategory}>
            <i className="fa fa-lg fa-trash" />
            <FormattedMessage id="ids_delete" />
          </Button>
        )}
      </Col>
      <Col xs={2} />
      <Col xs={5}>
        <SaveButton
          workInProgress={workInProgress}
          className="btn-fill pull-right margin-left-20"
          onClick={validate}
        />
      </Col>
    </SideModal>
  );
};

export default compose(
  injectIntl,
  data,
  withLoadingWait,
  categoriesParent,
  categoryName,
  categoryFamilyName,
  categoryActive,
  category,
  errors,
  handlers,
  pure
)(CreateCategorySideModal);
